import { Link } from 'react-router-dom';

const FOOTER_LINKS = [
  { label: '首页', path: '/' },
  { label: '电影', path: '/category/电影' },
  { label: '电视剧', path: '/category/电视剧' },
  { label: '综艺', path: '/category/综艺' },
  { label: '搜索', path: '/search' },
  { label: '关于我们', path: '/about' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center font-heading font-extrabold text-lg">
                91
              </span>
              <span className="font-heading font-extrabold text-xl text-background-50">
                91大神影视大全
              </span>
            </div>
            <p className="text-sm text-primary-100/80 leading-relaxed max-w-sm">
              聚合最新电影、电视剧与综艺栏目，提供清晰的分类、搜索与筛选体验，让每一次找片都更轻松。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-base text-background-50 mb-4">
              快速导航
            </h3>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-4">
              {FOOTER_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-primary-100/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-base text-background-50 mb-4">
              联系我们
            </h3>
            <ul className="space-y-3 text-sm text-primary-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400" />
                support@91dashen.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-base text-accent-400" />
                微信公众号：91大神影视
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-accent-400" />
                每日 09:00 - 22:00 在线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-100/60 text-center sm:text-left">
            本站为影视内容展示演示站点，所有影视资料与数据仅用于演示，不提供实际播放与下载服务。
          </p>
          <p className="text-xs text-primary-100/60">© 2024 91大神影视大全 · 演示用途</p>
        </div>
      </div>
    </footer>
  );
}